export enum HttpStatus {
  HTTP_400_BAD_REQUEST = 400,
  HTTP_200_OK = 200,
  HTTP_401_UNAUTHORIZED = 401,
  HTTP_402_PAYMENT_REQUIRED = 402,
  HTTP_403_FORBIDDEN = 403,
  HTTP_404_NOT_FOUND = 404,
  HTTP_500_INTERNAL_SERVER_ERROR = 500,

  // Audio
  HTTP_200_AUDIO_EXISTS = 2001,
  HTTP_400_COQUI_TTS_ERROR = 4001,

  // auth
  HTTP_400_USER_EXISTS = 4002,
  HTTP_400_PHONE_EXISTS = 4003,
  HTTP_400_EMAIL_EXISTS = 4004,
  HTTP_400_CODE_ERROR = 4005,
}